import React from 'react';
import styles from './StatusFilter.module.css';
import { useTranslation } from 'react-i18next';
interface StatusFilterProps {
  title: string;
  isSelected: boolean;
  onClick: () => void;
  iconColor?: string;
  count?: number;
  isHighlighted?: boolean;
  disabled?: boolean;
}

const StatusFilter: React.FC<StatusFilterProps> = ({
  title,
  isSelected,
  onClick,
  iconColor,
  count,
  isHighlighted,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const handleClick = () => {
    if (disabled) return;
    onClick();
  };
  return (
    <button
      type="button"
      disabled={disabled}
      className={`${styles.filterButton} ${isSelected ? styles.filterButtonHasValue : ''} ${disabled ? styles.filterButtonDisabled : ''}`}
      onClick={handleClick}
    >
      {iconColor && (
        <div
          className={`${styles.statusIcon} ${isHighlighted ? styles.statusIconHighlighted : ''}`}
          style={{ backgroundColor: iconColor, '--dot-color': iconColor } as React.CSSProperties}
        />
      )}
      <div>
        <span className={`${isSelected ? 'body-sm-semibold' : 'body-sm-regular'} text-(--font-body-1)`}>{t(title)}</span>
        {count !== undefined && (
          <span className="body-sm-regular text-(--font-body-2)" style={{ marginInlineStart: '4px' }}>
            ({count})
          </span>
        )}
      </div>
    </button>
  );
};

export default StatusFilter;
